var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewBtnArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.749878 4.77873C0.351464 4.77873 0.0284855 5.10171 0.0284856 5.50012C0.0284856 5.89854 0.351464 6.22151 0.749878 6.22151V4.77873ZM13.5024 6.01022C13.7841 5.7285 13.7841 5.27174 13.5024 4.99002L8.9115 0.399109C8.62978 0.117388 8.17302 0.117388 7.8913 0.399109C7.60958 0.68083 7.60958 1.13759 7.8913 1.41931L11.9721 5.50012L7.8913 9.58093C7.60957 9.86265 7.60958 10.3194 7.8913 10.6011C8.17302 10.8829 8.62978 10.8829 8.9115 10.6011L13.5024 6.01022ZM0.749878 5.50012V6.22151H12.9923V5.50012V4.77873H0.749878V5.50012Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBtnArrow);
export default __webpack_public_path__ + "static/media/view-btn-arrow.c0be5c51c00157d5036685d895f9c285.svg";
export { ForwardRef as ReactComponent };